/** Reloads the current pathname, query, and hash after explicit user confirmation. */
export const reloadFrontend = (): void => window.location.reload();
